import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { get, isEmpty } from 'lodash'
import { asyncConnect } from 'redux-connect'
import { renderRoutes } from 'react-router-config'
import ReactGA from 'react-ga4'
import store from 'store'

import {
  isLoaded as isAuthLoaded,
  load as loadAuth,
  setActiveOrganization,
} from 'redux/modules/auth'
import { getLocalizedMessages, saveCookieLocale } from 'redux/modules/app'
import { Utils, InitPage } from 'containers/misc'
import { messages, intlData } from 'constants/locales'
import prototypes from 'utils/prototypes'
import { locales, activityMonitor, refreshToken } from 'helpers/decorators'
import ga from 'utils/ga'
import { Notification } from 'components/misc'
import { toDash, getLocaleFromStore } from 'utils/intl'
import { getActiveOrganization } from 'utils/token'
import 'assets/css/main.styl'
import ScrollToTop from 'components/misc/ScrollToTop/ScrollToTop'

@asyncConnect([
  {
    promise: ({ store: { dispatch, getState }, helpers }) => {
      const promises = []

      if (!isAuthLoaded(getState())) {
        promises.push(dispatch(loadAuth()))
      }

      const cookieLocaleCode = get(helpers, 'client.cookieLocaleCode')

      // posibly call API from here and hold render
      promises.push(
        dispatch(
          saveCookieLocale({
            code: cookieLocaleCode,
          })
        )
      )

      return Promise.all(promises)
    }
  }
])
@connect(
  state => ({
    locale: state.app.locale,
    misc: state.app.misc,
    organization: state.auth.organization,
    user: state.auth.user,
    serverMessages: state.app.messages,
    serverMessagesFetchCompleted: state.app.messagesFetchComplete,
    messagesFetchedLocaleCode: state.app.messagesFetchedLocaleCode
  }),
  { setActiveOrganization, getLocalizedMessages }
)
@activityMonitor()
@refreshToken()
@locales()
class App extends Component {
  static propTypes = {
    changeLocale: PropTypes.func.isRequired,
    translatedMessages: PropTypes.object,
    locale: PropTypes.object.isRequired,
    toggleOnlineStatus: PropTypes.func,
    getLocalizedMessages: PropTypes.func,
    isOffline: PropTypes.bool,
    location: PropTypes.object,
    locales: PropTypes.object,
    refreshPage: PropTypes.bool,
    user: PropTypes.object
  }

  componentWillMount = async () => {
    prototypes()
    this.handleChangeActiveOrganization(this.props.user)
    this.handleChangeActiveOrganization(this.props.user)

    this.props.getLocalizedMessages({
      code: this.currentLocale,
    })
  }

  componentDidMount () {
    try {
      this.handleEnableAnalytics()
    } catch (err) {
      console.error('Error setting up google analytics')
    }
  }

  componentWillReceiveProps(nextProps) {
    this.handleChangeActiveOrganization(nextProps.user)

    if (get(this.props, 'location.pathname') !== get(nextProps, 'location.pathname')) {
      ReactGA.send(get(nextProps, 'location.pathname'))
    }
  }

  get currentLocale() {
    const { locale, localeFromUrl } = this.props

    return (
      localeFromUrl || get(locale, 'cookieLocaleCode') || get(getLocaleFromStore(), 'code') || get(locale, 'code')
    )
  }

  handleChangeActiveOrganization = user => {
    const { organization } = this.props

    if (!user) {
      return
    }
    if (
      !store.get(`activeOrganization-${get(user, 'personId')}`) &&
      !(organization?.id) &&
      getActiveOrganization(user).id
    ) {
      this.props.setActiveOrganization(getActiveOrganization(user))
      return
    }

    if (store.get(`activeOrganization-${get(user, 'personId')}`)) {
      const activeOrganization = JSON.parse(
        store.get(`activeOrganization-${get(user, 'personId')}`)
      )

      if (
        activeOrganization.id !== organization.id ||
        activeOrganization.userType !== organization.userType ||
        activeOrganization.regionId !== organization.regionId
      ) {
        this.props.setActiveOrganization(activeOrganization)
        return
      }
    }
  }

  handleEnableAnalytics = () => {
    ga({ page: get(this.props, 'location.pathname') })
  }

  render() {
    const {
      serverMessagesFetchCompleted,
      messagesFetchedLocaleCode,
      route,
      misc,
      serverMessages
    } = this.props

    if (!serverMessagesFetchCompleted) {
      return null
    }

    const currentLocale = toDash(this.currentLocale)

    if(messagesFetchedLocaleCode && currentLocale !== messagesFetchedLocaleCode){
      this.props.getLocalizedMessages({ code: currentLocale })
    }

    let translatedMessage = messages[currentLocale] || messages['en-gb']

    const hasServerMessages =
      serverMessages[currentLocale] && !isEmpty(Object.keys(serverMessages[currentLocale]))

    if (hasServerMessages) {
      translatedMessage = serverMessages[currentLocale]
    }

    return (
      <div>
        <IntlProvider
        key={hasServerMessages ? 'clientIntl' : 'serverIntl'}
        locale={toDash(currentLocale)}
        formats={intlData[currentLocale]}
        messages={translatedMessage}
        >
          <div className='page__wrapper'>
            {renderRoutes(route.routes, { currentLocale })}
            <Notification />
            <Utils noConnection={misc.noConnection} refreshPage={misc.refreshPage} />
          </div>
        </IntlProvider>
        <InitPage />
        <ScrollToTop />
      </div>
    )
  }
}

export default App
